import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { Typography } from "@mui/material";

interface TreatmentOtherInfoSymbolProps {
  checked: boolean | null;
}

const TreatmentOtherInfoSymbol = (props: TreatmentOtherInfoSymbolProps) => {
  const { checked } = props;

  if (checked === null) {
    return <Typography>N/A</Typography>;
  }
  if (checked) {
    return <CheckCircleOutlineIcon style={{ color: "#005D50" }} fontSize="small" />;
  }
  return <CancelOutlinedIcon style={{ color: "#CC0033" }} fontSize="small" />;
};

export default TreatmentOtherInfoSymbol;
